import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const Leaders = styled.div`
    display: grid;
    grid-template: 1fr / 1fr / 1fr / 1fr;
    padding-top: 20px;
    gap: ${BaseStyle.GAP_SIZES.large}px;

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        grid-template: auto 1fr / 1fr 1fr;
        gap: ${BaseStyle.GAP_SIZES.huge}px ${BaseStyle.GAP_SIZES.large}px;
    }
`;

export const FeaturedStatsContainer = styled.div`
    padding: 64px 0;

    .cmsFeaturedStatsContainer {
        background: ${({ theme }) => theme.Surface.secondary};
        padding: 24px;
    }

    .module {
        display: flex;
        flex-direction: column;
    }

    .category {
        flex: 1;
    }

    p {
        ${BaseStyle.Mixins.fontStyles.desktop.subtitle2}
    }

    ul {
        padding-bottom: 24px;

        &:last-child {
            padding-bottom: 0;
        }
    }

    li {
        ${BaseStyle.Mixins.fontStyles.desktop.body2}
        list-style-type: initial;
        list-style-position: inside;
        padding-left: 8px;
    }

    a:hover {
        font-weight: bold;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        .module {
            flex-direction: row;
        }
    }
`;
